// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-section {
  margin-top: 15px;
}

.fbpvalidation-page .header-text {
  padding-bottom: 15px;
}
.fbpvalidation-page .bck-button {
  position: absolute;
  right: 15px;
  top: 15px;
}
.fbpvalidation-page .tableData .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) {
  background: var(--color-light-blue);
}
.fbpvalidation-page .tableData .rdt_TableBody .rdt_TableRow:last-child .rdt_TableCell {
  background: var(--lighter-green);
  font-weight: 700;
}
.fbpvalidation-page .tableData .rdt_TableBody .rdt_TableRow:nth-last-child(2) .rdt_TableCell {
  background: var(--color-lightGreen);
  font-weight: 700;
}
.fbpvalidation-page .permutation-table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) {
  background: transparent;
}
.fbpvalidation-page .permutation-table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2) {
  background: transparent;
}
.fbpvalidation-page .permutation-table .rdt_TableBody .rdt_TableRow:last-child .rdt_TableCell {
  background: transparent;
  font-weight: 500;
}
.fbpvalidation-page .permutation-table .rdt_TableBody .rdt_TableRow:nth-last-child(2) .rdt_TableCell {
  background: transparent;
  font-weight: 500;
}
.fbpvalidation-page .dropdown-box {
  width: 47%;
}
.fbpvalidation-page .validation-section {
  font-size: var(--font-size-md);
}
.fbpvalidation-page .validation-section .sendValidation-box {
  display: flex;
}
.fbpvalidation-page .validation-section .sendValidation-box ul {
  list-style-type: none;
  margin: 0px;
  padding: 0px;
  height: 15rem;
}
.fbpvalidation-page .validation-section .sendValidation-box ul li {
  padding: 10px 15px;
  border-bottom: solid 1px var(--border-color);
  position: relative;
  cursor: pointer;
}
.fbpvalidation-page .validation-section .sendValidation-box ul li.active {
  background: var(--color-light-blue);
}
.fbpvalidation-page .validation-section .sendValidation-box ul li .icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--color-green);
}
.fbpvalidation-page .validation-section .sendValidation-box .left-section {
  position: relative;
  width: 47%;
  height: 15rem;
}
.fbpvalidation-page .validation-section .sendValidation-box .left-section .validation-box {
  border: 1px solid var(--border-color);
  box-shadow: inset 1px 0px 2px 2px var(--color-light-gray);
  overflow-y: auto;
  border-radius: 4px;
}
.fbpvalidation-page .validation-section .sendValidation-box .validationBox-header {
  font-size: var(--font-size-md);
}
.fbpvalidation-page .validation-section .sendValidation-box .validationBox-header .asterisk {
  color: rgb(184, 0, 18);
}
.fbpvalidation-page .validation-section .sendValidation-box .arrow-section {
  width: 6%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;
}
.fbpvalidation-page .validation-section .sendValidation-box .arrow-section .arrows {
  width: 100%;
  text-align: center;
  cursor: pointer;
  margin-bottom: 5px;
}
.fbpvalidation-page .validation-section .sendValidation-box .arrow-section .arrows .icon {
  border: solid 1px var(--border-color);
  padding: 5px;
  border-radius: 50%;
}
.fbpvalidation-page .validation-section .sendValidation-box .right-section {
  width: 47%;
  position: relative;
}
.fbpvalidation-page .validation-section .sendValidation-box .right-section .validation-box {
  border: 1px solid var(--border-color);
  box-shadow: inset 1px 0px 2px 2px var(--color-light-gray);
  overflow-y: auto;
  border-radius: 4px;
}
.fbpvalidation-page .validation-section .sendValidation-box .right-section .validation-box.error-box {
  border-color: rgb(184, 0, 18);
}
.fbpvalidation-page .validation-section .sendValidation-box .right-section .error-msg {
  margin: 4px 0px 0px;
  color: rgb(184, 0, 18);
  font-size: 14px;
  line-height: 20px;
}
.fbpvalidation-page .button-section {
  text-align: right;
}
.fbpvalidation-page .button-section .button-wrapper {
  margin-left: 10px;
}
.fbpvalidation-page .tradeOwner-table-list {
  width: 60%;
}
.fbpvalidation-page .user-section .reviewer {
  border: solid 1px var(--border-color);
  padding: 10px;
  background: var(--bg-color-lightgray);
}
.fbpvalidation-page .user-section .reviewer .div-section {
  display: flex;
  align-items: center;
  padding: 10px;
  background: var(--color-white);
}
.fbpvalidation-page .user-section .reviewer .img-section .avatar {
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
}
.fbpvalidation-page .user-section .reviewer .name-section {
  margin-left: 25px;
}
.fbpvalidation-page .user-section .reviewer .name-section .tittle {
  font-weight: 700;
}
.fbpvalidation-page .user-section .reviewer .name-section .name {
  color: #42b0d5;
  font-weight: bold;
  font-size: 14px;
}
.fbpvalidation-page .comment-section .comment-div {
  border: 1px solid #f0f0f0;
  min-height: 45px;
  background: #fbfbfb;
  padding: 15px;
}
.fbpvalidation-page .comment-text {
  font-weight: 700;
}
.fbpvalidation-page .display-accept-trade-owner {
  color: #509946;
  margin-top: 4px;
  display: block;
  white-space: nowrap;
  background: #dcf4cb;
  padding: 10px 10px;
  line-height: 22px;
  border-radius: 3px;
  border: 1px solid;
}
.fbpvalidation-page .tableData-section .rejected {
  color: var(--color-red);
  font-weight: bold;
}
.fbpvalidation-page .tableData-section .accepted {
  color: var(--color-green);
  font-weight: bold;
}
.fbpvalidation-page .tableData-section .pending {
  font-weight: bold;
}

.exceptionCaseDetailTable table th {
  padding: 0;
}
.exceptionCaseDetailTable table th:first-child {
  padding-left: 1rem !important;
}

.delta-table table th,
.delta-table table td {
  font-size: var(--font-size-sm);
}
.delta-table table tbody td:first-child {
  padding: 0px;
}
.delta-table .total-value {
  color: var(--color-maersk-blue);
  font-weight: bold;
}
.delta-table .baseline-header,
.delta-table .highlight-basline-name {
  background-color: var(--table-select-bg-color);
}
.delta-table .proposal-header,
.delta-table .highlight-option-name {
  background-color: var(--table-select-option-bg-color);
}`, "",{"version":3,"sources":["webpack://./src/pages/FBPValidation/FBPValidation.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAGE;EACE,oBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AADJ;AAOQ;EACE,mCAAA;AALV;AAUQ;EACE,gCAAA;EACA,gBAAA;AARV;AAYQ;EACE,mCAAA;EACA,gBAAA;AAVV;AAsBQ;EACE,uBAAA;AApBV;AAuBQ;EACE,uBAAA;AArBV;AA0BQ;EACE,uBAAA;EACA,gBAAA;AAxBV;AA+BQ;EACE,uBAAA;EACA,gBAAA;AA7BV;AAmCE;EACE,UAAA;AAjCJ;AAoCE;EACE,8BAAA;AAlCJ;AAoCI;EACE,aAAA;AAlCN;AAoCM;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAlCR;AAoCQ;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;EACA,eAAA;AAlCV;AAoCU;EACE,mCAAA;AAlCZ;AAqCU;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,yBAAA;AAnCZ;AAwCM;EACE,kBAAA;EACA,UAAA;EACA,aAAA;AAtCR;AAwCQ;EACE,qCAAA;EACA,yDAAA;EACA,gBAAA;EACA,kBAAA;AAtCV;AA0CM;EACE,8BAAA;AAxCR;AA0CQ;EACE,sBAAA;AAxCV;AA4CM;EACE,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;AA1CR;AA4CQ;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AA1CV;AA4CU;EACE,qCAAA;EACA,YAAA;EACA,kBAAA;AA1CZ;AA+CM;EACE,UAAA;EACA,kBAAA;AA7CR;AA+CQ;EACE,qCAAA;EACA,yDAAA;EACA,gBAAA;EACA,kBAAA;AA7CV;AA+CU;EACE,6BAAA;AA7CZ;AAiDQ;EACE,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;AA/CV;AAqDE;EACE,iBAAA;AAnDJ;AAqDI;EACE,iBAAA;AAnDN;AAuDE;EACE,UAAA;AArDJ;AAyDI;EAEE,qCAAA;EACA,aAAA;EACA,qCAAA;AAxDN;AA0DM;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;AAxDR;AA4DQ;EACE,8EAAA;AA1DV;AA8DM;EACE,iBAAA;AA5DR;AA8DQ;EACE,gBAAA;AA5DV;AAgEQ;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AA9DV;AAqEI;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AAnEN;AAuEE;EACE,gBAAA;AArEJ;AAwEE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAtEJ;AA0EI;EACE,uBAAA;EACA,iBAAA;AAxEN;AA2EI;EACE,yBAAA;EACA,iBAAA;AAzEN;AA4EI;EACE,iBAAA;AA1EN;;AAiFI;EACE,UAAA;AA9EN;AAgFI;EACE,6BAAA;AA9EN;;AAqFI;;EAEE,8BAAA;AAlFN;AAqFM;EACE,YAAA;AAnFR;AAwFE;EACE,+BAAA;EACA,iBAAA;AAtFJ;AAyFE;;EAEE,8CAAA;AAvFJ;AA0FE;;EAEE,qDAAA;AAxFJ","sourcesContent":[".data-section {\n  margin-top: 15px;\n}\n\n.fbpvalidation-page {\n  .header-text {\n    padding-bottom: 15px;\n  }\n\n  .bck-button {\n    position: absolute;\n    right: 15px;\n    top: 15px;\n  }\n\n  .tableData {\n    .rdt_TableBody {\n      .rdt_TableRow {\n        .rdt_TableCell:nth-child(3) {\n          background: var(--color-light-blue);\n        }\n      }\n\n      .rdt_TableRow:last-child {\n        .rdt_TableCell {\n          background: var(--lighter-green);\n          font-weight: 700;\n        }\n      }\n      .rdt_TableRow:nth-last-child(2) {\n        .rdt_TableCell {\n          background: var(--color-lightGreen);\n          font-weight: 700;\n          // &:last-child{\n          //   background: var(--color-lightRed);\n          // }\n        }\n      }\n    }\n  }\n\n  .permutation-table {\n    .rdt_TableBody {\n      .rdt_TableRow {\n        .rdt_TableCell:nth-child(3) {\n          background: transparent;\n        }\n\n        .rdt_TableCell:nth-child(2) {\n          background: transparent;\n        }\n      }\n\n      .rdt_TableRow:last-child {\n        .rdt_TableCell {\n          background: transparent;\n          font-weight: 500;\n          // &:last-child{\n          //   background: var(--color-lightRed);\n          // }\n        }\n      }\n      .rdt_TableRow:nth-last-child(2) {\n        .rdt_TableCell {\n          background: transparent;\n          font-weight: 500;\n        }\n      }\n    }\n  }\n\n  .dropdown-box {\n    width: 47%;\n  }\n\n  .validation-section {\n    font-size: var(--font-size-md);\n\n    .sendValidation-box {\n      display: flex;\n\n      ul {\n        list-style-type: none;\n        margin: 0px;\n        padding: 0px;\n        height: 15rem;\n\n        li {\n          padding: 10px 15px;\n          border-bottom: solid 1px var(--border-color);\n          position: relative;\n          cursor: pointer;\n\n          &.active {\n            background: var(--color-light-blue);\n          }\n\n          .icon {\n            position: absolute;\n            right: 10px;\n            top: 50%;\n            transform: translateY(-50%);\n            color: var(--color-green);\n          }\n        }\n      }\n\n      .left-section {\n        position: relative;\n        width: 47%;\n        height: 15rem;\n\n        .validation-box {\n          border: 1px solid var(--border-color);\n          box-shadow: inset 1px 0px 2px 2px var(--color-light-gray);\n          overflow-y: auto;\n          border-radius: 4px;\n        }\n      }\n\n      .validationBox-header {\n        font-size: var(--font-size-md);\n\n        .asterisk {\n          color: rgb(184, 0, 18);\n        }\n      }\n\n      .arrow-section {\n        width: 6%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-wrap: wrap;\n        flex-direction: column;\n\n        .arrows {\n          width: 100%;\n          text-align: center;\n          cursor: pointer;\n          margin-bottom: 5px;\n\n          .icon {\n            border: solid 1px var(--border-color);\n            padding: 5px;\n            border-radius: 50%;\n          }\n        }\n      }\n\n      .right-section {\n        width: 47%;\n        position: relative;\n\n        .validation-box {\n          border: 1px solid var(--border-color);\n          box-shadow: inset 1px 0px 2px 2px var(--color-light-gray);\n          overflow-y: auto;\n          border-radius: 4px;\n\n          &.error-box {\n            border-color: rgb(184, 0, 18);\n          }\n        }\n\n        .error-msg {\n          margin: 4px 0px 0px;\n          color: rgb(184, 0, 18);\n          font-size: 14px;\n          line-height: 20px;\n        }\n      }\n    }\n  }\n\n  .button-section {\n    text-align: right;\n\n    .button-wrapper {\n      margin-left: 10px;\n    }\n  }\n\n  .tradeOwner-table-list {\n    width: 60%;\n  }\n\n  .user-section {\n    .reviewer {\n\n      border: solid 1px var(--border-color);\n      padding: 10px;\n      background: var(--bg-color-lightgray);\n\n      .div-section {\n        display: flex;\n        align-items: center;\n        padding: 10px;\n        background: var(--color-white);\n      }\n\n      .img-section {\n        .avatar {\n          box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;\n        }\n      }\n\n      .name-section {\n        margin-left: 25px;\n\n        .tittle {\n          font-weight: 700;\n\n        }\n\n        .name {\n          color: #42b0d5;\n          font-weight: bold;\n          font-size: 14px;\n        }\n      }\n    }\n  }\n\n  .comment-section {\n    .comment-div {\n      border: 1px solid #f0f0f0;\n      min-height: 45px;\n      background: #fbfbfb;\n      padding: 15px;\n    }\n  }\n\n  .comment-text {\n    font-weight: 700;\n  }\n\n  .display-accept-trade-owner {\n    color: #509946;\n    margin-top: 4px;\n    display: block;\n    white-space: nowrap;\n    background: #dcf4cb;\n    padding: 10px 10px;\n    line-height: 22px;\n    border-radius: 3px;\n    border: 1px solid;\n  }\n\n  .tableData-section {\n    .rejected {\n      color: var(--color-red);\n      font-weight: bold;\n    }\n\n    .accepted {\n      color: var(--color-green);\n      font-weight: bold;\n    }\n\n    .pending {\n      font-weight: bold;\n    }\n  }\n}\n\n.exceptionCaseDetailTable {\n  table {\n    th {\n      padding: 0;\n    }\n    th:first-child {\n      padding-left: 1rem !important;\n    }\n  }\n}\n\n.delta-table {\n  table {\n    th,\n    td {\n      font-size: var(--font-size-sm);\n    }\n    tbody {\n      td:first-child {\n        padding: 0px;\n      }\n    }\n  }\n\n  .total-value {\n    color: var(--color-maersk-blue);\n    font-weight: bold;\n  }\n\n  .baseline-header,\n  .highlight-basline-name {\n    background-color: var(--table-select-bg-color);\n  }\n\n  .proposal-header,\n  .highlight-option-name {\n    background-color: var(--table-select-option-bg-color);\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
